export const queryHome = groq`*[ _type == "homePage"][0]{
  ...,
  'isLightText': hero.heroBackground.lightText
}`;
